import React, {useRef, useEffect, useState} from 'react';
import Recaptcha from 'react-recaptcha';
import {generateUniqKey} from 'helpers/uniq';
import HelpBlock from './HelpBlock';
import {recaptchaFunctionName} from '../../constants/invisibleRecaptcha';

export default function FieldInvisibleCaptcha(props) {
	const {
		form,
		field,
		config,
		errors,
		onVerify,
		onExpired,
		onReady,
	} = props;

	const recaptchaRef = useRef(null);
	const retryCount = useRef(0);
	const maxRetries = 3;

	const executeRecaptcha = () => {
		if (recaptchaRef.current && retryCount.current < maxRetries) {
			recaptchaRef.current.execute();
			retryCount.current += 1;
		}
	};

	const handleLoad = () => {
		onReady?.();
		executeRecaptcha();
	};

	const handleVerify = (response) => {
		retryCount.current = 0;
		form.setFieldValue(field.name, response);
		onVerify?.(response);
	};

	const handleExpire = () => {
		form.setFieldValue(field.name, '');
		onExpired?.();
		setTimeout(() => {
			executeRecaptcha();
		}, 500);
	};

	useEffect(() => {
		const originalCallback = window[recaptchaFunctionName];
		window[recaptchaFunctionName] = () => {
			if (typeof originalCallback === 'function') {
				originalCallback();
			}
		};

		return () => {
			window[recaptchaFunctionName] = originalCallback;
		};
	}, []);

	useEffect(() => {
		const moveBadge = () => {
			const badge = document.querySelector('.grecaptcha-badge');
			if (badge) {
				if (badge.parentElement !== document.body) {
					document.body.appendChild(badge);
				}
				badge.style.zIndex = '9999';
			}
		};
		const interval = setInterval(moveBadge, 100);

		return () => clearInterval(interval);
	}, []);

	return (
		<>
			<Recaptcha
				ref={recaptchaRef}
				elementID={`g-recaptcha${generateUniqKey()}`}
				sitekey={config.key}
				size={config.size}
				render={config.render}
				expiredCallback={(response) => {
					form.setFieldValue(field.name, response);
					handleExpire();
				}}
				verifyCallback={(response) => {
					form.setFieldValue(field.name, response);
					handleVerify(response);
				}}
				onloadCallback={handleLoad}
				badge="bottomright"
                container="body"
			/>
			{errors !== undefined && errors[field.name] && (
				<HelpBlock>
					{errors[field.name]}
				</HelpBlock>
			)}
		</>
	);
}
